module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-left-2.3920325e.png";